import React from 'react';
import type { ViewMode } from '../../domain/types';
import { InspectorAside } from '../inspector/InspectorAside';
import { ChatAside } from '../chat/ChatAside';
import { MobileBottomNav } from './MobileBottomNav';

interface CompactOverlaysProps {
  isCompact: boolean;
  isChatOpen: boolean;
  inspectorSheetOpen: boolean;
  view: ViewMode;
  isDrawerOpen: boolean;
  onSelectView: (view: ViewMode) => void;
}

export const CompactOverlays: React.FC<CompactOverlaysProps> = ({
  isCompact,
  isChatOpen,
  inspectorSheetOpen,
  view,
  isDrawerOpen,
  onSelectView,
}) => {
  if (!isCompact) return null;
  return (
    <>
      {isChatOpen ? <ChatAside variant="sheet" /> : null}
      {inspectorSheetOpen && !isChatOpen ? <InspectorAside variant="sheet" /> : null}
      <MobileBottomNav activeView={view} isDrawerOpen={isDrawerOpen} onSelectView={onSelectView} />
    </>
  );
};

export function DesktopSidePanels({
  isCompact,
  view,
}: {
  isCompact: boolean;
  view: ViewMode;
}): React.ReactElement | null {
  if (isCompact || view === 'radar') return null;
  return (
    <>
      <ChatAside variant="docked" />
      <InspectorAside variant="docked" />
    </>
  );
}
